import { Select, SelectProps, TextInput } from "@mantine/core";
import styles from "./TextBox.module.scss";
import { UseFormReturnType } from "@mantine/form";

interface DropdownProps extends SelectProps {
    // value?: string;
    formInstance: UseFormReturnType<any>;
    name: string;
    data: string[] | { value: string; label: string }[];
    label?: string;
    description?: string;
    placeholder?: string;
    onChangeValue?: (value: string) => void;
    error?: string;
    // disabled?: boolean;
}

export const Dropdown = ({ formInstance, name, data, label, description, placeholder, onChangeValue, error, ...props }: DropdownProps) => {
    return (
        <Select
            data={data}
            label={label}
            description={description}
            placeholder={placeholder}
            {...formInstance.getInputProps(name)}
            error={error}
            {...props}
            // classNames={{
            //     root: styles.root,
            //     input: styles.input,
            //     wrapper: styles.wrapper,
            // }}
            styles={{
                input: {
                    borderColor: error ? "red" : undefined,
                    "&:focus": {
                        borderColor: error ? "red" : undefined,
                    },
                },
            }}
        />
    );
};